export const padStart = (value: number, maxLength = 2, fillString = "0") =>
  value.toString().padStart(maxLength, fillString);
